import { useState } from 'react'

import AutowidthInput from 'react-autowidth-input'
import { CheckIcon } from '@chakra-ui/icons'
import {
  Avatar,
  AvatarBadge,
  Box,
  Heading,
  HStack,
  IconButton,
  Input,
  Text,
  useDisclosure,
} from '@chakra-ui/react'

import { useUpdateUser, useUser } from '@/react-query/user'
import { PencilIcon } from '@/views/assets/PencilIcon'
import { PencilSvg } from '@/views/assets/PencilSvg'
import Card from '@/views/components/Card/Card'

import { SelectPictureModal } from './SelectPictureModal'

export const ProfileSettings = () => {
  const { data: user } = useUser()

  const { isOpen, onOpen, onClose } = useDisclosure()

  return (
    <Card w={'100%'} p={6} px={10}>
      <Heading size={'md'}>Profile</Heading>
      <HStack mt={6} wrap={'wrap'}>
        <Avatar
          h={'3.5rem'}
          w={'3.5rem'}
          name={user?.displayName || 'AA'}
          src={user?.photoURL || ''}
        >
          <AvatarBadge border={'none'}>
            <IconButton
              variant="brand-solid-white"
              icon={<PencilIcon fill={'white'} w={8} h={8} />}
              aria-label="Edit user picture"
              size={'sm'}
              onClick={onOpen}
            />
          </AvatarBadge>
        </Avatar>
        <UserName />
        <Email />
      </HStack>
      <SelectPictureModal isOpen={isOpen} onClose={onClose} />
    </Card>
  )
}

const UserName = () => {
  const updateUser = useUpdateUser()
  const [isEditing, setIsEditing] = useState(false)
  const { data: user } = useUser()
  const [localUserName, setLocalUserName] = useState(user?.displayName || '')

  return (
    <HStack>
      <Box ml={4}>
        {isEditing ? (
          <Input
            minW={'100px'}
            pr={0}
            value={localUserName}
            onChange={(e) => setLocalUserName(e.target.value)}
            variant={'brand-solid-white'}
            as={AutowidthInput}
          />
        ) : (
          <Text minW={'116px'} pr={4}>
            {user?.displayName}
          </Text>
        )}
      </Box>
      <IconButton
        onClick={async (e) => {
          e.preventDefault()
          if (isEditing) {
            updateUser.mutate({
              user: { displayName: localUserName || '' },
            })
          } else {
            setLocalUserName(user?.displayName || '')
          }
          setIsEditing((isEditing) => !isEditing)
        }}
        variant="brand-solid-white"
        icon={isEditing ? <CheckIcon /> : <PencilSvg />}
        aria-label="Edit user name"
      />
    </HStack>
  )
}

const Email = () => {
  const { data: user } = useUser()
  return (
    <Text fontWeight={'semibold'} ml={6}>
      {user?.email}
    </Text>
  )
}
